module.exports = __webpack_public_path__ + "img/done.fdc2c6a0.svg";